module.exports = __webpack_public_path__ + "img/gaoxinjishu.43d2d974.jpg";